import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
export const VersionsListContainer = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("versions-list-container flex h-full w-full flex-1 shrink-0 items-center justify-start overflow-auto pb-4 [&>*]:shrink-0"),
        children: children
    });
});
VersionsListContainer.displayName = "VersionsListContainer";
